export default {"src":"/_next/static/media/ourPartnersIcon.9ee38fa6.svg","height":63,"width":60};